import { useTranslation } from "react-i18next"
import { UserTypeFilter } from "../../../../../@client/Theasoft_ApiServer_Users"

export function useLocalizedUserTypeFilter() {
  const { t } = useTranslation("app_server")
  return (userTypeFilter: UserTypeFilter) => {
    switch (userTypeFilter) {
      case "Users":
        return t("Users")
      case "Groups":
        return t("Groups")
      case "UsersAndGroups":
        return t("UsersAndGroups")
    }
  }
}
